import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CrossVizientOpinionEnum } from '../../../../../types/types';

@Component({
    selector: 'app-vizient-assessment-vote',
    templateUrl: './vizient-assessment-vote.component.html',
    styleUrls: ['./vizient-assessment-vote.component.scss'],
    standalone: false
})
export class VizientAssessmentVoteComponent {
  @Input() hasPermissionToAddOpinions = false;
  @Input() opinion = '';
  @Output() updateOpinion = new EventEmitter();
  crossVizientOpinionEnum = CrossVizientOpinionEnum;

  constructor() {}

  toggleDeniedVoteClick() {
    const votedOpinionKey =
      this.opinion === CrossVizientOpinionEnum.DENIED
        ? CrossVizientOpinionEnum.NO_OPINION
        : CrossVizientOpinionEnum.DENIED;

    this.updateOpinion.emit({
      opinionOptionKey: votedOpinionKey,
    });
  }

  toggleApprovedVoteClick() {
    const votedOpinionKey =
      this.opinion === CrossVizientOpinionEnum.APPROVED
        ? CrossVizientOpinionEnum.NO_OPINION
        : CrossVizientOpinionEnum.APPROVED;

    this.updateOpinion.emit({
      opinionOptionKey: votedOpinionKey,
    });
  }
}
